import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {Observable, Subject} from 'rxjs';
import {debounceTime, takeUntil, tap} from 'rxjs/operators';
import {CommandStatus, CommandStatusType, CommandType} from 'src/app/core/models/command-response';
import {SetCommandFailure, SetCommandSuccess} from 'src/app/core/store/panel-outputs/panel-outputs.actions';
import {PanelOutputsStateSelectors} from 'src/app/core/store/panel-outputs/panel-outputs.selectors';
import {PanelOutputLockingStatus} from '../../core/models/panel-output-locking-status';

@Component({
  selector: 'app-lock-actions',
  templateUrl: './lock-actions.component.html',
  styleUrls: ['./lock-actions.component.scss']
})
export class LockActionsComponent implements OnInit, OnDestroy {

  @Select(PanelOutputsStateSelectors.commandStatus) command$: Observable<CommandStatus>;

  @Output() onLockClick: EventEmitter<void> = new EventEmitter<void>();
  @Output() onUnlockClick: EventEmitter<void> = new EventEmitter<void>();

  @Input() itemStatus: PanelOutputLockingStatus | string;
  @Input() isLocking: boolean;
  @Input() isUnlocking: boolean;

  status = PanelOutputLockingStatus;

  private destroy$ = new Subject<boolean>();

  constructor(private store: Store) {
  }

  ngOnInit() {

    this.command$.pipe(
      debounceTime(2000),
      tap(currentCommand => {

        if (currentCommand.status === CommandStatusType.Pending) {
          this.commandSuccessTest(currentCommand) ? this.store.dispatch(new SetCommandSuccess(currentCommand.type)) : this.store.dispatch(new SetCommandFailure(currentCommand.type));
        }
      }),
      takeUntil(this.destroy$)
    ).subscribe();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  release() {
    this.onUnlockClick.emit();
  }

  lockdown() {
    this.onLockClick.emit();
  }

  private commandSuccessTest(currentCommand: CommandStatus): boolean {
    return !((currentCommand.type === CommandType.Lockdown && this.itemStatus === PanelOutputLockingStatus.Locked) || (currentCommand.type === CommandType.Release && this.itemStatus === PanelOutputLockingStatus.Unlocked));
  }

}
